<template>
    <div>
      <ul>
        <li >
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            {{source.id}}
            {{ get(source.translations, $store.state.locale, 'name')}}
          </h3>
<ul class="overflow-hidden bg-white divide-y divide-gray-200 rounded-md shadow">
      <li v-for="(dish) in source.dishes" :key="dish.id" class="bg-white ">

              
              <div class="block transition duration-150 ease-in-out focus:outline-none focus:bg-gray-50">
                <div class="flex items-center px-4 py-4 sm:px-6">
                  <div class="flex items-center flex-1 min-w-0">

                    <div class="flex-1 min-w-0 md:grid md:grid-cols-2 md:gap-4">
                      <div>
                        <div class="flex justify-between">
                        <div class="text-base font-medium leading-5" :class="'text-'+$store.state.color.primary">
                          {{ get(dish.translations, $store.state.locale, 'name')}}
                        </div>
                        <div>
                          <button @click="addProductToCart(dish)">
                              <svg class="w-5 h-5 fill-current " :class="'text-'+$store.state.color.primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M256 0C114.833 0 0 114.833 0 256s114.833 256 256 256 256-114.853 256-256S397.167 0 256 0zm0 472.341c-119.275 0-216.341-97.046-216.341-216.341S136.725 39.659 256 39.659 472.341 136.705 472.341 256 375.295 472.341 256 472.341z"/>
                                <path d="M355.148 234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83 8.884-19.83 19.83v79.318h-79.318c-10.966 0-19.83 8.884-19.83 19.83s8.864 19.83 19.83 19.83h79.318v79.318c0 10.946 8.864 19.83 19.83 19.83s19.83-8.884 19.83-19.83v-79.318h79.318c10.966 0 19.83-8.884 19.83-19.83s-8.864-19.83-19.83-19.83z"/>
                              </svg>
                          </button>
                        </div>
                        </div>
                        <p class="mt-2 text-sm">
                          {{ get(dish.translations, $store.state.locale, 'description')}}
                        </p>
                        
                        <div class="flex">
                          <div class="w-1/3 mt-2">
                            <p 
                            class="inline-flex items-center px-2 text-xs font-medium leading-5 rounded-md"
                            :class="'text-' + $store.state.color.primary+' bg-' + $store.state.color.secondary" 
                            v-if="dish.price">
                              {{ dish.price }} {{ dish.unit }}
                            </p>
                          </div>


                          <div class="w-2/3 mt-2 text-right">
                              <div>
                              <span v-for="(allergen) in dish.checked_allergies" :key="'dish_'+dish.id+'_'+allergen">
                                <v-popover class="inline-block">
 
                                  <img :src="'https://static.menubyte.it/icons/allergens/'+ getAllergen(allergen).icon+'.svg'" 
                                  class="inline-block p-1 mr-1 w-7 h-7">
 
                                  <template slot="popover" >
                                      <span class="text-sm">{{get(getAllergen(allergen).translations, $store.state.locale, 'name')}}</span>
                                  </template>
                                  
                                </v-popover>                                
                              </span>
                              </div>
                          
                              <div>
                              <span v-for="(attribute) in dish.checked_attributes" :key="'dish_'+dish.id+'_'+attribute">
                                <v-popover class="inline-block">


                                  <img :src="'https://static.menubyte.it/icons/attributes/'+ getAttribute(attribute).icon+'.svg'" 
                                  class="inline-block p-1 mr-1 w-7 h-7">

                                  <template slot="popover" >
                                      <span class="text-sm">{{get(getAttribute(attribute).translations, $store.state.locale, 'name')}}</span>
                                  </template>
                                
                                </v-popover>                                
                              </span>


                              </div>

                          </div>
                  
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--
                <div  :class="indexdish === (cat.dishes.length-1) ? '' : 'border-t mx-3'"></div>
                -->
              </div>
              
            </li>
</ul>
        </li>
      </ul>
           
    </div>
</template>

<script>
import Translations from "../../../apis/Translations";
import { mapActions } from 'vuex'

  export default {
    name: 'item-component',
    props: {
      index: { // index of current item
        type: Number
      },
      source: { // here is: {uid: 'unique_1', text: 'abc'}
        type: Object,
        default () {
          return {}
        }
      }
    },
    methods:{
      ...mapActions("cart", [
        "addProductToCart"
      ]),

      get: function(translations, locale, prop){
        return Translations.get(translations, locale, prop);
      },

      getAllergen: function(allergen_id){
        let r = this.$store.state.location.allergies.filter(x => x.id == allergen_id);
        if (r.length > 0){
          return r[0];
        }
      },

      getAttribute: function(attribute_id){
        let r = this.$store.state.location.attributes.filter(x => x.id == attribute_id);
        if (r.length > 0){
          return r[0];
        }
      },
      
    }
  }
</script>

<style>

</style>